import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Table,
  Stack,
  Pagination,
  styled,
  Avatar,
  Chip,
  TextField,
  Button,
  CircularProgress,
  Checkbox,
  Snackbar,
  Alert,
} from "@mui/material";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import Header from "../../../components/header";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../components/AnimatedLoader";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import FormattedDate from "../../../components/FormattedDate";
import {
  convertTimeToMinutes,
  convertCallDuration,
  getFirstLetter,
} from "../../../utils/common";
import dialerIcon from "../../../assets/table_call_icon.svg";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import NewFilter from "../../../components/NewFilter";
import NoData from "../../../components/NoData";
import CommonFilter from "../../../components/CommonFilter";
import { jwtDecode } from "jwt-decode";
import { Category } from "@mui/icons-material";


const getRandomAccentColor = () => {
  const colors = ["#10B981", "#6366F1", "#F59E0B", "#3B82F6", "#EC4899"];
  return colors[Math.floor(Math.random() * colors.length)];
};


const TableHeading = styled(TableCell)({
  textTransform: "uppercase",
  fontWeight: 550,
  color: "#6b7280",
  fontSize: "0.7rem",
  backgroundColor: "#f9fafb",
  whiteSpace: "nowrap",
});

const AudioTable = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const isMPokket = decodedToken?.companyName === "mPokket";
  const isVxpressNmc = decodedToken?.companyName === "vxpressnmc";
  const isCurator = decodedToken?.userRole === "Curator";
  const [data, setData] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [paginationData, setPaginationData] = useState({});
  const [payloadData, setPayloadData] = useState();
  const [exportData, setExportData] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdatingQA, setIsUpdatingQA] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  console.log(exportData, "exportData");

  const location = useLocation();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPage(1); // reset pagination on new search
    }, 500); // ⏱️ debounce delay (400–600ms is ideal)

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);



  const isFilter = {
    date: true,
    filter: true,
    callScore:
      ["67e560a6ae2e0d3f96b5eb08", "67e560a6ae2e0d3f96b5eb09"].includes(decodedToken?.companyId) ? true : false,
  };

  useEffect(() => {
    fetchAudioDetails();
  }, [page, payloadData, debouncedSearch]);

  useEffect(() => {
    fetchAgentCampaignDetails();
  }, []);

  // Company-specific default date range — only used when the user hasn't picked their own
  // filter yet (unlike the old COMPANY_DATE_FILTERS, this never overrides a chosen filter).
  const DEFAULT_DATE_RANGE_BY_COMPANY = {
    "67e560a6ae2e0d3f96b5eb09": {
      startDate: "2026-08-11",
      endDate: "2026-08-17",
    },
  };

  const getDateRangeByCompany = () => {
    const today = new Date().toISOString().split("T")[0];
    const companyId = decodedToken?.companyId;

    const defaultRange = DEFAULT_DATE_RANGE_BY_COMPANY[companyId] || {
      startDate: today,
      endDate: today,
    };

    return {
      startDate: payloadData?.filters?.startDate || defaultRange.startDate,
      endDate: payloadData?.filters?.endDate || defaultRange.endDate,
    };
  };

  const fetchAudioDetails = async () => {
    const { startDate, endDate } = getDateRangeByCompany();
    // const today = new Date();
    // const todayStr = today?.toISOString().split("T")[0];
    // const isLockedCompany =
    //   decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb09";

    // const fixedDateStartDate = "2026-02-01";
    // const fixedDateEndDate = "2026-02-28";

    const payload = {
      // startDate: payloadData?.filters?.startDate
      //   ? payloadData?.filters?.startDate
      //   : today?.toISOString().split("T")[0],
      // endDate: payloadData?.filters?.endDate
      //   ? payloadData?.filters?.endDate
      //   : today?.toISOString().split("T")[0],
      // startDate: isLockedCompany ? fixedDateStartDate : payloadData?.filters?.startDate || todayStr,
      // endDate: isLockedCompany ? fixedDateEndDate : payloadData?.filters?.endDate || todayStr,
      startDate,
      endDate,
      agentName:
        payloadData?.filters?.agents?.length > 0
          ? payloadData?.filters?.agents
          : [],
      sentiment:
        payloadData?.filters?.sentiment?.length > 0
          ? payloadData?.filters?.sentiment
          : [],
      campaign:
        payloadData?.filters?.campaigns?.length > 0
          ? payloadData?.filters?.campaigns
          : [],
      callDurationText:
        payloadData?.filters?.callDuration?.length > 0
          ? payloadData?.filters?.callDuration
          : [],
      callDirection:
        payloadData?.filters?.callInteraction?.length > 0
          ? payloadData?.filters?.callInteraction
          : [],
      searchTerm: debouncedSearch,
      // complianceStatus:
      //   payloadData?.selectedCompliance?.length > 0
      //     ? payloadData?.selectedCompliance
      //     : [],
      disposition:
        payloadData?.filters?.disposition?.length > 0
          ? payloadData?.filters?.disposition
          : [],
      conversionStatus:
        payloadData?.filters?.conversionStatus?.length > 0
          ? payloadData?.filters?.conversionStatus
          : [],
      categoryDistribution:
        payloadData?.filters?.categoryDistribution?.length > 0
          ? payloadData?.filters?.categoryDistribution
          : [],
      subDisposition:
        payloadData?.filters?.subDisposition?.length > 0
          ? payloadData?.filters?.subDisposition
          : [],
      frequentKeywords: payloadData?.frequentKeywords || "",
      callScore:
        payloadData?.filters?.callScore?.length > 0
          ? payloadData?.filters?.callScore
          : [],
      page: page,
      limit: 10,
      pagination: true,
    };
    try {
      const res = await axiosInstance.post(
        `${apiEndPointsConfig?.interactionList}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setData(res?.data?.data?.interactionList || []);
      setPaginationData(res?.data?.data?.paginator || {});
      setLoader(false);
    } catch (error) {
      console.error("Error fetching audio details", error);
    }
  };
  const exportToCSV = (data) => {
    if (!data || data.length === 0) return;

    // Extract keys (columns)
    const headers = Object.keys(data[0]);

    // Convert rows
    const rows = data.map((row) =>
      headers.map((field) => JSON.stringify(row[field] ?? "")).join(",")
    );

    // CSV string
    const csvContent = [headers.join(","), ...rows].join("\n");

    // Create & download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", `export_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const fetchExportDetails = async () => {
  //   const today = new Date();
  //   const payload = {
  //     startDate: payloadData?.filters?.startDate
  //       ? payloadData?.filters?.startDate
  //       : today?.toISOString().split("T")[0],
  //     endDate: payloadData?.filters?.endDate
  //       ? payloadData?.filters?.endDate
  //       : today?.toISOString().split("T")[0],
  //     agentName:
  //       payloadData?.filters?.agents?.length > 0
  //         ? payloadData?.filters?.agents
  //         : [],
  //     sentiment:
  //       payloadData?.filters?.sentiment?.length > 0
  //         ? payloadData?.filters?.sentiment
  //         : [],
  //     campaign:
  //       payloadData?.filters?.campaigns?.length > 0
  //         ? payloadData?.filters?.campaigns
  //         : [],
  //     callDurationText:
  //       payloadData?.filters?.callDuration?.length > 0
  //         ? payloadData?.filters?.callDuration
  //         : [],
  //     callDirection:
  //       payloadData?.filters?.callInteraction?.length > 0
  //         ? payloadData?.filters?.callInteraction
  //         : [],
  //     searchTerm: searchQuery,
  //     // complianceStatus:
  //     //   payloadData?.selectedCompliance?.length > 0
  //     //     ? payloadData?.selectedCompliance
  //     //     : [],
  //     disposition:
  //       payloadData?.filters?.disposition?.length > 0
  //         ? payloadData?.filters?.disposition
  //         : [],
  //     subDisposition:
  //       payloadData?.filters?.subDisposition?.length > 0
  //         ? payloadData?.filters?.subDisposition
  //         : [],
  //     frequentKeywords: payloadData?.frequentKeywords || "",
  //     callScore:
  //       payloadData?.filters?.callScore?.length > 0
  //         ? payloadData?.filters?.callScore
  //         : [],
  //     page: page,
  //     limit: 10,
  //     pagination: false,
  //   };
  //   try {
  //     const res = await axiosInstance.post(
  //       `${apiEndPointsConfig?.interactionList}`,
  //       payload,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     const exportList = res?.data?.data?.interactionList || [];
  //     setExportData(res?.data?.data?.interactionList || []);
  //     exportToCSV(exportList);
  //   } catch (error) {
  //     console.error("Error fetching audio details", error);
  //   }
  // };

  const fetchExportExcel = async () => {
    setIsExporting(true);
    const today = new Date();
    const payload = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
      agentName:
        payloadData?.filters?.agents?.length > 0
          ? payloadData?.filters?.agents
          : [],
      sentiment:
        payloadData?.filters?.sentiment?.length > 0
          ? payloadData?.filters?.sentiment
          : [],
      campaign:
        payloadData?.filters?.campaigns?.length > 0
          ? payloadData?.filters?.campaigns
          : [],
      callDurationText:
        payloadData?.filters?.callDuration?.length > 0
          ? payloadData?.filters?.callDuration
          : [],
      callDirection:
        payloadData?.filters?.callInteraction?.length > 0
          ? payloadData?.filters?.callInteraction
          : [],
      searchTerm: debouncedSearch,
      disposition:
        payloadData?.filters?.disposition?.length > 0
          ? payloadData?.filters?.disposition
          : [],
      conversionStatus:
        payloadData?.filters?.conversionStatus?.length > 0
          ? payloadData?.filters?.conversionStatus
          : [],
      categoryDistribution:
        payloadData?.filters?.categoryDistribution?.length > 0
          ? payloadData?.filters?.categoryDistribution
          : [],
      subDisposition:
        payloadData?.filters?.subDisposition?.length > 0
          ? payloadData?.filters?.subDisposition
          : [],
      frequentKeywords: payloadData?.frequentKeywords || "",
      callScore:
        payloadData?.filters?.callScore?.length > 0
          ? payloadData?.filters?.callScore
          : [],
    };

    try {
      const res = await axiosInstance.post(
        `${apiEndPointsConfig?.exportExcelInteraction}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      );

      console.log(res, "execl data of interaction----------------");


      if (!res.data) {
        console.error("No data received from server");
        setIsExporting(false);
        return;
      }

      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `interaction_export_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      // const exportList = res?.data?.data || [];
      // setExportData(res?.data?.data || []);
      // exportToCSV(exportList);

      setIsExporting(false);
      console.log("Export completed successfully");

    } catch (error) {
      console.error("Error exporting Excel file", error);
      console.error("Error details:", error.response || error.message);
      setIsExporting(false);
      alert("Failed to export data. Please try again.");
    }
  };

  const fetchAgentCampaignDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig?.agentCampaignList}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAgentList(res?.data?.data?.agentName);
      setCampaignList(res?.data?.data?.campaignName);
    } catch (error) {
      console.error("Error fetching audio details", error);
    }
  };


  console.log(payloadData, "payloadData");

  const extractMobile = (fileName) => {
    return fileName.split("-")[1]?.split(".")[0];
  };
  function compactId(id) {
    return id?.slice(-5);
  }
  const toTitleCase = (str = "") =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const handleExportExcel = () => { };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.transcriptionId);
      setSelectedRows(newSelecteds);
      return;
    }
    setSelectedRows([]);
  };

  const handleSelectRow = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }
    setSelectedRows(newSelected);
  };

  const handleUpdateQAParameters = async () => {
    if (selectedRows.length === 0) {
      setSnackbar({ open: true, message: "Please select at least one record to update.", severity: "warning" });
      return;
    }
    try {
      setIsUpdatingQA(true);
      const res = await axiosInstance.put(
        `${apiEndPointsConfig?.updateMultipleQaParameters}`,
        { transcriptionIds: selectedRows },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const message = res?.data?.message || "QA Parameters updated successfully!";
      setSnackbar({ open: true, message: message, severity: "success" });

      setSelectedRows([]);
      fetchAudioDetails();
    } catch (error) {
      console.error("Error updating QA parameters", error);
      const errorMessage = error?.response?.data?.message || "Failed to update QA parameters. Please try again.";
      setSnackbar({ open: true, message: errorMessage, severity: "error" });
    } finally {
      setIsUpdatingQA(false);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleToggleCuration = async (row) => {
    const newValue = !row.isCurated;
    // Optimistic update
    setData((prev) =>
      prev.map((item) =>
        item.transcriptionId === row.transcriptionId
          ? { ...item, isCurated: newValue }
          : item
      )
    );
    try {
      await axiosInstance.post(
        `${apiEndPointsConfig?.toggleCuration}`,
        { interactionId: row.interactionId, isCurated: newValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("Error toggling curation", error);
      // Roll back on failure
      setData((prev) =>
        prev.map((item) =>
          item.transcriptionId === row.transcriptionId
            ? { ...item, isCurated: !newValue }
            : item
        )
      );
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Failed to update curation status.",
        severity: "error",
      });
    }
  };

  return (
    <Box sx={{}}>
      {loader ? (
        <Loader />
      ) : (
        <Box sx={{ p: { xs: 1.5, md: 3 }, backgroundColor: "#F8F8FA" }}>
          {/* Filters */}
          <Box
            sx={{
              // border: "1px solid #EEEEEE",
              // p: "10px 15px",
              borderRadius: 2.5,
              // backgroundColor: "#fff",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <TextField
                size="small"
                variant="outlined"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setPage(1);
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    // "& fieldset": {
                    //   borderColor: "#6366F1",
                    // },
                    "&:hover fieldset": {
                      borderColor: "#6366F1",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#6366F1",
                    },
                    "& .MuiInputBase-input": {
                      // color: "#6366F1",
                      // fontWeight: 600,
                      // p: "10px 20px",
                      fontSize: 14,
                    },
                    borderRadius: 2,
                    p: "5px 20px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Box
                      component="span"
                      sx={{
                        color: "#6366F1",
                        mr: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 24 24"
                        width="20"
                        fill="#6366F1"
                      >
                        <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 14a4 4 0 110-8 4 4 0 010 8z" />
                      </svg>
                    </Box>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                alignItems: "center",
              }}
            >
              <CommonFilter
                storageName={"interactionFilter"}
                setPayloadData={setPayloadData}
                isFilter={isFilter}
              />
              {isCurator && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isUpdatingQA || selectedRows.length === 0}
                  onClick={handleUpdateQAParameters}
                  sx={{
                    height: "35px",
                    backgroundColor: "#7635dd",
                    borderRadius: "12px",
                    "&:hover": {
                      backgroundColor: "#5f2ab8",
                    },
                    "&:disabled": {
                      backgroundColor: "#c4b5e0",
                    },
                  }}
                  startIcon={
                    isUpdatingQA ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null
                  }
                >
                  {isUpdatingQA ? "Updating..." : "Update QA"}
                </Button>
              )}
              {/* <Button
                variant="contained"
                color="primary"
                sx={{
                  height: "35px",
                  width: { xs: "100%", lg: "150px" },
                  backgroundColor: "#7635dd",
                  borderRadius: "12px",
                }}
                onClick={fetchExportDetails}
              >
                Export
              </Button> */}
              <Button
                variant="contained"
                color="primary"
                disabled={isExporting}
                sx={{
                  height: "35px",
                  width: { xs: "100%", lg: "150px" },
                  backgroundColor: "#7635dd",
                  borderRadius: "12px",
                  "&:hover": {
                    backgroundColor: "#5f2ab8",
                  },
                  "&:disabled": {
                    backgroundColor: "#c4b5e0",
                  },
                }}
                onClick={fetchExportExcel}
                startIcon={
                  isExporting ? (
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                  ) : null
                }
              >
                {isExporting ? "Exporting..." : "Export"}
              </Button>
            </Box>
          </Box>

          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              border: "1px solid #EEEEEE",
              borderRadius: 2,
              overflowX: "auto",
              mt: 3,
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {isCurator && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        indeterminate={selectedRows.length > 0 && selectedRows.length < data.length}
                        checked={data.length > 0 && selectedRows.length === data.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                  )}
                  <TableHeading>Agent </TableHeading>
                  <TableHeading>Customer </TableHeading>
                  <TableHeading>Call Intent</TableHeading>
                  {/* {isMPokket && (
                    <>
                      <TableHeading>externalUserId</TableHeading>
                      <TableHeading>mobile number</TableHeading>
                      <TableHeading>callDate</TableHeading>
                    </>
                  )} */}
                  {isVxpressNmc && (
                    <>
                      <TableHeading>mobile number</TableHeading>
                      <TableHeading>Google sheet </TableHeading>
                    </>
                  )}
                  <TableHeading sx={{ textAlign: "center" }}>
                    Campaign{" "}
                  </TableHeading>
                  {decodedToken.companyId === "67e560a6ae2e0d3f96b5eb08" && <TableHeading sx={{ textAlign: "center" }}>
                    Conversion Status
                  </TableHeading>}
                  <TableHeading sx={{ textAlign: "center" }}>
                    {" "}
                    Duration
                  </TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>
                    Direction
                  </TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>
                    Sentiment
                  </TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>
                    Compliance
                  </TableHeading>
                  <TableHeading sx={{ textAlign: "center" }}>
                    Call Score
                  </TableHeading>
                  {/* <TableHeading>Status</TableHeading> */}
                  {/* <TableHeading sx={{ textAlign: "center" }}>
                    Created On
                  </TableHeading> */}
                  {isCurator && (
                    <TableHeading>File Base Name</TableHeading>
                  )}
                  {isCurator && (
                    <TableHeading sx={{ textAlign: "center" }}>
                      Curate
                    </TableHeading>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length == 0 ? (
                  <TableRow>
                    <TableCell colSpan={17} align="center">
                      <NoData />
                    </TableCell>
                  </TableRow>
                ) : (
                  data?.map((row, index) => {
                    const isItemSelected = selectedRows.indexOf(row.transcriptionId) !== -1;
                    return (
                      <TableRow
                        key={row.id}
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        selected={isItemSelected}
                      >
                        {isCurator && (
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              onChange={(event) => handleSelectRow(event, row.transcriptionId)}
                            />
                          </TableCell>
                        )}
                        {/* agent nmae */}
                        <TableCell
                          sx={{
                            cursor: "pointer",
                            color:
                              row?.transcriptionStatus == "Completed"
                                ? "#7635DD"
                                : "grey",
                            whiteSpace: "nowrap",
                            fontSize: "0.8rem",
                            fontWeight: 550,
                            "&:hover": {
                              color:
                                row?.transcriptionStatus === "Completed"
                                  ? "#1976d2"
                                  : "grey",
                            },
                          }}
                          onClick={() => {
                            if (row?.transcriptionStatus == "Completed") {
                              window.open(
                                `/user/audio-analytics/${row.transcriptionId}`,
                                "_blank"
                              );

                              // navigate(
                              //   `/user/audio-analytics/${row.transcriptionId}`
                              // );
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              // alignItems: "center",
                              gap: 1,
                              "&:hover": {
                                color:
                                  row?.transcriptionStatus === "Completed"
                                    ? "#1976d2"
                                    : "",
                              },
                            }}
                          >
                            <Avatar
                              sx={{
                                bgcolor: "#7635DD",
                                // bgcolor: "transparent",
                                // color: "#7635DD",
                                width: 28,
                                height: 28,
                                fontSize: 12,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                border: "1px solid #7635DD",
                                "&:hover": {
                                  bgcolor:
                                    row?.transcriptionStatus === "Completed"
                                      ? "#1976d2"
                                      : "",
                                  color: "#fff",
                                },
                              }}
                            >
                              {getFirstLetter(row?.agentName) || "NA"}
                            </Avatar>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {" "}
                              <Box>{row?.agentName}</Box>
                              <Box
                                sx={{
                                  fontWeight: 500,
                                  color: "grey",
                                }}
                              >
                                Agent ID: #{compactId(row?.agentId)}{" "}
                              </Box>{" "}
                            </Box>
                          </Box>
                        </TableCell>

                        {/* customer nmae */}
                        <TableCell
                          sx={{
                            color: "grey",
                            whiteSpace: "nowrap",
                            fontSize: "0.8rem",
                            fontWeight: 550,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              gap: 1,
                            }}
                          >
                            <Avatar
                              sx={{
                                fontSize: 12,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                bgcolor: "#666666",
                                width: 28,
                                height: 28,
                              }}
                            >
                              {getFirstLetter(row?.customerName) || "U"}
                            </Avatar>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {" "}
                              <Box>
                                {row?.customerName
                                  ? toTitleCase(row?.customerName)
                                  : "UnKnown"}
                              </Box>
                              <Box
                                sx={{
                                  fontWeight: 500,
                                  color: "grey",
                                }}
                              >
                                Customer
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>

                        {/* Call intent   */}
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            color: "#666666",
                          }}
                        >
                          <Box
                            sx={{
                              fontWeight: "bold",
                              // color: "#00539F",
                            }}
                          >
                            {/* <Typography sx={{fontSize:12,fontWeight:"bold"}}> */}
                            {row?.callIntent}
                            <Box
                              sx={{
                                fontWeight: 500,
                                color: "grey",
                              }}
                            >
                              Dialer ID: #{compactId(row?.dialerId)}{" "}
                            </Box>
                            {/* </Typography> */}
                          </Box>{" "}
                        </TableCell>


                        {/* {isMPokket && (
                          <>
                            <TableCell
                              sx={{
                                fontSize: "0.8rem",
                                color: "#666666",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                {row?.externalUserId}

                              </Box>{" "}

                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "0.8rem",
                                color: "#666666",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                {row?.dnis}

                              </Box>{" "}

                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "0.8rem",
                                color: "#666666",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                {row?.endTime}

                              </Box>{" "}

                            </TableCell>
                          </>
                        )} */}
                        {isVxpressNmc && (
                          <>
                            <TableCell>
                              {row?.campaignMobile}
                            </TableCell>
                            <TableCell>
                              {row?.customerDocument ? "Available" : "N/A"}
                            </TableCell>
                          </>
                        )}
                        {/* Call Campaign   */}
                        <TableCell
                          sx={{
                            fontSize: "0.7rem",
                            // color: "#919191",
                            color: "#666666",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Box
                            sx={{
                              display: "inline-block",
                              borderRadius: 2,
                              border: "1px solid grey",
                              p: 0.5,
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {row?.campaignName}
                          </Box>{" "}
                        </TableCell>
                        {decodedToken.companyId === "67e560a6ae2e0d3f96b5eb08" &&
                          <TableCell
                            sx={{
                              fontSize: "0.8rem",
                              fontWeight: 550,
                              color: "#919191",
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <Box
                                sx={{
                                  fontWeight: 900,
                                  textTransform: "capitalize",
                                  color:
                                    row?.conversionInsightsOutcome === 'Converted'
                                      ? "success.main"        // green
                                      : row?.conversionInsightsOutcome === 'Follow-up Required'
                                        ? "warning.light"       // 🟡 light yellow
                                        : "error.light",        // 🔴 light red
                                }}
                              >
                                {row?.conversionInsightsOutcome}
                              </Box>
                            </Box>
                          </TableCell>
                        }

                        {/* Call Type   */}
                        {/* <TableCell
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666666",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center", // horizontal center
                            alignItems: "center", // vertical center
                          }}
                        >
                          <Typography
                            sx={{
                              backgroundColor: "#B1B1B1",
                              borderRadius: 5,
                              px: 1.2,
                              py: 0.3,
                              fontSize: "0.7rem",
                              color: "#fff",
                              display: "inline-block",
                            }}
                          >
                            {row?.callType}
                          </Typography>
                        </Box>
                      </TableCell> */}

                        {/* call duration  */}
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 550,
                            color: "#919191",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 1,
                            }}
                          >
                            {" "}
                            <Box
                              component="img"
                              src={dialerIcon}
                              alt="call"
                              sx={{
                                width: 20,
                                height: 20,
                                objectFit: "contain",
                              }}
                            />
                            {/* {convertTimeToMinutes(row?.callDuration)} min */}
                            {convertCallDuration(row?.callDuration)}
                          </Box>
                        </TableCell>

                        {/* Call direction   */}
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 550,
                            color: "#919191",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            {row?.callDirection === "Inbound" ? (
                              <>
                                <CallReceivedIcon
                                  sx={{
                                    fontSize: 18,
                                    color: "#EC4899",
                                  }}
                                />
                                <Box
                                  sx={{
                                    textTransform: "capitalize",
                                    color: "#EC4899",
                                    fontWeight: 600,
                                  }}
                                >
                                  {row?.callDirection}
                                </Box>
                              </>
                            ) : (
                              <>
                                <ArrowOutwardIcon
                                  sx={{
                                    fontSize: 18,
                                    color: "#7635DD",
                                  }}
                                />
                                <Box
                                  sx={{
                                    textTransform: "capitalize",
                                    color: "#7635DD",
                                    fontWeight: 600,
                                  }}
                                >
                                  {row?.callDirection}
                                </Box>
                              </>
                            )}
                          </Box>
                        </TableCell>

                        {/* sentiment */}
                        <TableCell>
                          <Typography
                            sx={{
                              color:
                                row?.overAllSentiment == "Neutral"
                                  ? "#F59E0B"
                                  : row?.overAllSentiment == "Positive"
                                    ? "green"
                                    : "#FF4D4F",
                            }}
                            variant="body2"
                            fontWeight={600}
                            display="flex"
                            alignItems="center"
                          >
                            {row?.overAllSentiment === "Unknown" ? (
                              <Box
                                sx={{
                                  color: "black",
                                }}
                              >
                                N/A
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                {row?.overAllSentiment === "Negative" ? (
                                  <SentimentVeryDissatisfiedIcon
                                    style={{ color: "#FF4D4F" }}
                                  />
                                ) : row?.overAllSentiment === "Neutral" ? (
                                  <SentimentNeutralIcon
                                    sx={{ color: "#F59E0B", fontSize: 22 }}
                                  />
                                ) : row?.overAllSentiment === "Positive" ? (
                                  <SentimentSatisfiedAltIcon
                                    style={{ color: "green" }}
                                  />
                                ) : (
                                  ""
                                )}{" "}
                                {row?.overAllSentiment || "NA"}
                              </Box>
                            )}
                          </Typography>
                        </TableCell>

                        {/* call Compliance */}
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 520,
                            color: "#111827",
                          }}
                        >
                          {row?.callAdherenceRating == "N/A" ? (
                            "N/A"
                          ) : (
                            <>
                              <Chip
                                label={row?.complianceStatus ? "Pass" : "Fail"}
                                size="small"
                                sx={{
                                  backgroundColor: row?.complianceStatus
                                    ? "green"
                                    : "#FF4D4F",
                                  color: "#fff",
                                  px: 0.5,
                                  py: 0.5,
                                  borderRadius: 20,
                                  fontWeight: 700,
                                }}
                              />
                            </>
                          )}
                        </TableCell>
                        {/* call Score */}
                        <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 550,
                            color: "#919191",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Box
                              sx={{
                                fontWeight: 900,
                                textTransform: "capitalize",
                                color:
                                  row?.callScore >= 80
                                    ? "success.main"        // green
                                    : row?.callScore >= 70
                                      ? "warning.light"       // 🟡 light yellow
                                      : "error.light",        // 🔴 light red
                              }}
                            >
                              {row?.callScore}%
                            </Box>
                          </Box>
                        </TableCell>

                        {/* statuys */}
                        {/* <TableCell
                          sx={{
                            textTransform: "capitalize",
                            fontSize: "0.8rem",
                            fontWeight: 520,
                          }}
                        >
                          {row?.transcriptionStatus == "failed" ? (
                            <Box color={"red"}>failed</Box>
                          ) : (
                            <Box
                              sx={{
                                borderRadius: 2,
                                textAlign: "left",
                                p: 0.2,
                              }}
                            >
                              {row?.transcriptionStatus == null
                                ? "in-progress"
                                : row?.transcriptionStatus}
                            </Box>
                          )}
                            </TableCell> */}

                        {/* <TableCell
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 520,
                          }}
                        >
                          {row?.createdOn}
                          <FormattedDate dateString={row?.createdOn} />
                        </TableCell> */}

                        {isCurator && (
                          <TableCell sx={{ fontSize: "0.8rem", color: "#666666" }}>
                            {row?.fileBaseName || "N/A"}
                          </TableCell>
                        )}

                        {isCurator && (
                          <TableCell sx={{ textAlign: "center" }}>
                            <Button
                              size="small"
                              variant={row.isCurated ? "contained" : "outlined"}
                              onClick={() => handleToggleCuration(row)}
                              sx={{
                                textTransform: "none",
                                borderRadius: 5,
                                fontSize: "0.7rem",
                                minWidth: 80,
                                ...(row.isCurated
                                  ? { backgroundColor: "#118D57", "&:hover": { backgroundColor: "#0e7a4a" } }
                                  : { borderColor: "#7635DD", color: "#7635DD" }),
                              }}
                            >
                              {row.isCurated ? "Curated" : "Curate"}
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Stack
            spacing={2}
            sx={{ mt: 2, display: "flex", alignItems: "flex-end", p: 2 }}
          >
            <Typography variant="body2" color="text.secondary">
              {paginationData?.itemCount > 0
                ? `Showing ${(paginationData?.currentPage - 1) *
                paginationData?.perPage +
                1
                }–${Math.min(
                  paginationData?.currentPage * paginationData?.perPage,
                  paginationData?.itemCount
                )} of ${paginationData?.itemCount} results`
                : "No results found"}
            </Typography>

            <Pagination
              count={paginationData?.pageCount || 1}
              page={paginationData?.currentPage || 1}
              onChange={(event, value) => {
                setPage(value);
              }}
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "#7635DD",
                  borderColor: "#7635DD",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#7635DD !important",
                  color: "#fff !important",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#E0E7FF",
                },
              }}
            />
          </Stack>
        </Box>
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%", boxShadow: 3 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AudioTable;

// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Paper,
//   Stack,
//   Pagination,
//   TextField,
//   styled,
//   Avatar,
//   Chip,
//   Button,
// } from "@mui/material";
// import { useDebounce } from "react-use";
// import { jwtDecode } from "jwt-decode";

// import axiosInstance from "../../../services/axiosInterceptors";
// import apiEndPointsConfig from "../../../services/apiEndPoints";
// import Header from "../../../components/header";
// import Loader from "../../../components/AnimatedLoader";
// import NoData from "../../../components/NoData";
// import CommonFilter from "../../../components/CommonFilter";
// import FormattedDate from "../../../components/FormattedDate";
// import { convertCallDuration, getFirstLetter } from "../../../utils/common";
// import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
// import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
// import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
// import CallReceivedIcon from "@mui/icons-material/CallReceived";
// import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
// import dialerIcon from "../../../assets/table_call_icon.svg";
// import { palette, theme as colorTheme } from "../../../Convoze.theme";
// import ParentWrapper from "../../../components/ParentWrapper";

// /* ---------- styled ---------- */
// const TableHeading = styled(TableCell)({
//   textTransform: "uppercase",
//   fontWeight: 550,
//   // color: "#6b7280",
//   color: colorTheme("palette", "secondary").value,
//   fontSize: "0.7rem",
//   backgroundColor: "white",
//   whiteSpace: "nowrap",
// });

// /* ---------- helpers ---------- */
// const buildCacheKey = (page, payload, search) =>
//   `p${page}-${JSON.stringify(payload)}-${search}`;

// const compactId = (id) => id?.slice(-5);
// const toTitleCase = (str = "") =>
//   str
//     .toLowerCase()
//     .split(" ")
//     .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
//     .join(" ");

// /* ========== SUB-COMPONENTS ========== */
// const SearchBar = ({ value, onChange }) => (
//   <TextField
//     size="small"
//     placeholder="Search"
//     value={value}
//     onChange={onChange}
//     sx={{
//       width: { xs: "100%", md: "100%", lg: "20%" },
//       backgroundColor: colorTheme("palette", "white").value,
//       borderRadius: 2,
//       "& .MuiOutlinedInput-root": {
//         p: "1px 20px",
//         "&:hover fieldset": {
//           borderColor: colorTheme("palette", "primary").value,
//         },
//         "&.Mui-focused fieldset": {
//           borderColor: colorTheme("palette", "primary").value,
//         },
//         "& .MuiInputBase-input": { fontSize: 14 },
//         borderRadius: 3,
//       },
//     }}
//     InputProps={{
//       startAdornment: (
//         <Box
//           component="span"
//           sx={{
//             color: colorTheme("palette", "primary").value,
//             mr: 1,
//             display: "flex",
//           }}
//         >
//           <svg
//             width="20"
//             height="20"
//             viewBox="0 0 24 24"
//             fill={colorTheme("palette", "primary").value}
//           >
//             <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 14a4 4 0 110-8 4 4 0 010 8z" />
//           </svg>
//         </Box>
//       ),
//     }}
//   />
// );

// const AgentCell = ({ row }) => (
//   <TableCell
//     sx={{
//       cursor: "pointer",
//       color:
//         row?.transcriptionStatus === "Completed"
//           ? colorTheme("palette", "primary").value
//           : colorTheme("palette", "secondary").value,
//       whiteSpace: "nowrap",
//       fontSize: "0.8rem",
//       fontWeight: 550,
//       "&:hover": {
//         color:
//           row?.transcriptionStatus === "Completed"
//             ? colorTheme("palette", "primary").value
//             : colorTheme("palette", "secondary").value,
//       },
//     }}
//     onClick={() =>
//       row?.transcriptionStatus === "Completed" &&
//       window.open(`/user/audio-analytics/${row.transcriptionId}`, "_blank")
//     }
//   >
//     <Box sx={{ display: "flex", gap: 1 }}>
//       <Avatar
//         sx={{
//           // bgcolor: "#7635DD",
//           bgcolor: colorTheme("palette", "primary").value,
//           width: 28,
//           height: 28,
//           fontSize: 12,
//           // border: "1px solid #7635DD",
//           border: `1px solid ${colorTheme("palette", "primary").value}`,
//         }}
//       >
//         {getFirstLetter(row?.agentName) || "NA"}
//       </Avatar>
//       <Box sx={{ display: "flex", flexDirection: "column" }}>
//         <Box>{row?.agentName}</Box>
//         <Box
//           sx={{
//             fontWeight: 500,
//             color: colorTheme("palette", "secondary").value,
//             fontSize: 12,
//           }}
//         >
//           Agent ID: #{compactId(row?.agentId)}
//         </Box>
//       </Box>
//     </Box>
//   </TableCell>
// );

// const CustomerCell = ({ row }) => (
//   <TableCell
//     sx={{
//       color: "grey",
//       whiteSpace: "nowrap",
//       fontSize: "0.8rem",
//       fontWeight: 550,
//     }}
//   >
//     <Box sx={{ display: "flex", gap: 1 }}>
//       <Avatar
//         sx={{
//           fontSize: 12,
//           bgcolor: colorTheme("palette", "secondary").value,
//           width: 28,
//           height: 28,
//         }}
//       >
//         {getFirstLetter(row?.customerName) || "U"}
//       </Avatar>
//       <Box sx={{ display: "flex", flexDirection: "column" }}>
//         <Box>
//           {row?.customerName ? toTitleCase(row?.customerName) : "Unknown"}
//         </Box>
//         <Box
//           sx={{
//             fontWeight: 500,
//             color: colorTheme("palette", "secondary").value,
//             fontSize: 12,
//           }}
//         >
//           Customer
//         </Box>
//       </Box>
//     </Box>
//   </TableCell>
// );

// const IntentCell = ({ intent }) => (
//   <TableCell
//     sx={{ fontSize: "0.8rem", color: colorTheme("palette", "secondary").value }}
//   >
//     <Box sx={{ fontWeight: "bold" }}>{intent}</Box>
//   </TableCell>
// );

// const CampaignCell = ({ campaign }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.7rem",
//       color: colorTheme("palette", "secondary").value,
//       whiteSpace: "nowrap",
//     }}
//   >
//     <Box
//       sx={{
//         display: "inline-block",
//         borderRadius: 2,
//         // border: "1px solid grey",
//         border: `1px solid ${colorTheme("palette", "secondary").value}`,
//         p: 0.5,
//         width: "100%",
//         textAlign: "center",
//       }}
//     >
//       {campaign}
//     </Box>
//   </TableCell>
// );

// const DurationCell = ({ duration }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.8rem",
//       fontWeight: 550,
//       color: colorTheme("palette", "secondary").value,
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 1,
//       }}
//     >
//       <Box
//         component="img"
//         src={dialerIcon}
//         alt="call"
//         sx={{ width: 20, height: 20, objectFit: "contain" }}
//       />
//       {convertCallDuration(duration)}
//     </Box>
//   </TableCell>
// );

// const DirectionCell = ({ direction }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.8rem",
//       fontWeight: 550,
//       color: colorTheme("palette", "secondary").value,
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 0.5,
//       }}
//     >
//       {direction === "Inbound" ? (
//         <>
//           <CallReceivedIcon
//             sx={{ fontSize: 18, color: colorTheme("palette", "primary").value }}
//           />
//           <Box
//             sx={{
//               textTransform: "capitalize",
//               color: colorTheme("palette", "primary").value,
//               fontWeight: 600,
//             }}
//           >
//             {direction}
//           </Box>
//         </>
//       ) : (
//         <>
//           <ArrowOutwardIcon
//             sx={{ fontSize: 18, color: colorTheme("palette", "primary").value }}
//           />
//           <Box
//             sx={{
//               textTransform: "capitalize",
//               color: colorTheme("palette", "primary").value,
//               fontWeight: 600,
//             }}
//           >
//             {direction}
//           </Box>
//         </>
//       )}
//     </Box>
//   </TableCell>
// );

// const SentimentCell = ({ sentiment }) => (
//   <TableCell>
//     <Typography
//       sx={{
//         color:
//           sentiment === "Neutral"
//             ? colorTheme("palette", "neutral").value
//             : sentiment === "Positive"
//               ? colorTheme("palette", "positive").value
//               : colorTheme("palette", "negative").value,
//       }}
//       variant="body2"
//       fontWeight={600}
//       display="flex"
//       alignItems="center"
//       justifyContent="center"
//     >
//       {sentiment === "Unknown" ? (
//         <Box sx={{ color: "black" }}>N/A</Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1 }}>
//           {sentiment === "Negative" && (
//             <SentimentVeryDissatisfiedIcon
//               style={{ color: colorTheme("palette", "negative").value }}
//             />
//           )}
//           {sentiment === "Neutral" && (
//             <SentimentNeutralIcon
//               sx={{
//                 color: colorTheme("palette", "neutral").value,
//                 fontSize: 22,
//               }}
//             />
//           )}
//           {sentiment === "Positive" && (
//             <SentimentSatisfiedAltIcon
//               style={{ color: colorTheme("palette", "positive").value }}
//             />
//           )}
//           {sentiment}
//         </Box>
//       )}
//     </Typography>
//   </TableCell>
// );

// const ComplianceCell = ({ status, rating }) => (
//   <TableCell
//     sx={{
//       fontSize: "0.8rem",
//       textAlign: "center",
//       fontWeight: 520,
//       color: colorTheme("palette", "night").value,
//     }}
//   >
//     {rating === "N/A" ? (
//       "N/A"
//     ) : (
//       <Chip
//         label={status ? "Pass" : "Fail"}
//         size="small"
//         sx={{
//           // backgroundColor: status ? colorTheme('palette', 'positive').value : colorTheme('palette', 'negative').value,
//           // color: colorTheme('palette', 'white').value,
//           background: "transparent",
//           border: `1px solid ${status
//             ? colorTheme("palette", "positive").value
//             : colorTheme("palette", "negative").value
//             }`,
//           color: status
//             ? colorTheme("palette", "positive").value
//             : colorTheme("palette", "negative").value,
//           px: 0.5,
//           py: 0.5,
//           borderRadius: 20,
//           fontWeight: 700,
//         }}
//       />
//     )}
//   </TableCell>
// );

// const DateCell = ({ date }) => (
//   <TableCell sx={{ fontSize: "0.8rem", fontWeight: 520, textAlign: "center" }}>
//     <FormattedDate dateString={date} />
//   </TableCell>
// );

// /* ========== MAIN COMPONENT ========== */
// const AudioTable = () => {
//   const token = localStorage.getItem("token");
//   const decodedToken = token ? jwtDecode(token) : "";

//   /* ---------------- state ---------------- */
//   const [audioList, setAudioList] = useState([]);
//   const [agentList, setAgentList] = useState([]);
//   const [campaignList, setCampaignList] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(true);
//   const [searchInput, setSearchInput] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [paginationInfo, setPaginationInfo] = useState({});
//   const [filterPayload, setFilterPayload] = useState();
//   const [cacheMap, setCacheMap] = useState({});

//   /* -------------- debounce -------------- */
//   useDebounce(() => setDebouncedSearch(searchInput), 400, [searchInput]);

//   /* -------------- data -------------- */
//   const fetchAudioDetails = useCallback(async () => {
//     const today = new Date().toISOString().split("T")[0];

//     const body = {
//       startDate: filterPayload?.filters?.startDate || today,
//       endDate: filterPayload?.filters?.endDate || today,
//       agentName: filterPayload?.filters?.agents?.length
//         ? filterPayload.filters.agents
//         : [],
//       sentiment: filterPayload?.filters?.sentiment?.length
//         ? filterPayload.filters.sentiment
//         : [],
//       campaign: filterPayload?.filters?.campaigns?.length
//         ? filterPayload.filters.campaigns
//         : [],
//       callDurationText: filterPayload?.filters?.callDuration?.length
//         ? filterPayload.filters.callDuration
//         : [],
//       callDirection: filterPayload?.filters?.callInteraction?.length
//         ? filterPayload.filters.callInteraction
//         : [],
//       disposition: filterPayload?.filters?.disposition?.length
//         ? filterPayload.filters.disposition
//         : [],
//       subDisposition: filterPayload?.filters?.subDisposition?.length
//         ? filterPayload.filters.subDisposition
//         : [],
//       callScore: filterPayload?.filters?.callScore?.length
//         ? filterPayload.filters.callScore
//         : [],
//       frequentKeywords: filterPayload?.frequentKeywords || "",
//       searchTerm: debouncedSearch,
//       page: currentPage,
//       limit: 10,
//       pagination: true,
//     };

//     const key = buildCacheKey(currentPage, filterPayload, debouncedSearch);

//     if (cacheMap[key]) {
//       console.log("AudioTable: cache hit", key);
//       setAudioList(cacheMap[key].list);
//       setPaginationInfo(cacheMap[key].pagination);
//       setIsLoading(false);
//       return;
//     }

//     try {
//       console.log("AudioTable: API call", key);
//       const res = await axiosInstance.post(
//         apiEndPointsConfig.interactionList,
//         body,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const list = res?.data?.data?.interactionList || [];
//       const paginator = res?.data?.data?.paginator || {};
//       setAudioList(list);
//       setPaginationInfo(paginator);
//       setCacheMap((prev) => ({
//         ...prev,
//         [key]: { list, pagination: paginator },
//       }));
//     } catch (err) {
//       console.error("AudioTable: API error", err);
//       setAudioList([]);
//       setPaginationInfo({});
//     } finally {
//       setIsLoading(false);
//     }
//   }, [currentPage, filterPayload, debouncedSearch, cacheMap, token]);

//   const fetchAgentAndCampaigns = useCallback(async () => {
//     try {
//       const res = await axiosInstance.get(
//         apiEndPointsConfig.agentCampaignList,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setAgentList(res?.data?.data?.agentName || []);
//       setCampaignList(res?.data?.data?.campaignName || []);
//     } catch (err) {
//       console.error("AudioTable: agents/campaigns error", err);
//     }
//   }, [token]);

//   /* -------------- effects -------------- */
//   useEffect(() => {
//     fetchAudioDetails();
//   }, [fetchAudioDetails]);

//   useEffect(() => {
//     fetchAgentAndCampaigns();
//   }, [fetchAgentAndCampaigns]);

//   // set current page to one add new
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filterPayload, debouncedSearch]);

//   /* -------------- render -------------- */
//   const isFilter = { date: true, filter: true };

//   // if (isLoading) return <Loader />;

//   // return (
//   //   <Box sx={{ ml: { xs: "0px", md: "280px" } }}>
//   //     <Box sx={{ display: { xs: "none", md: "initial" } }}>
//   //       <Header title="Interactions" />
//   //     </Box>

//   //     <Box sx={{ p: { xs: 1.5, md: 3 }, backgroundColor: "#F8F8FA" }}>
//   //       {/* Search + Filters */}
//   //       <Box sx={{ borderRadius: 2.5, display: "flex", justifyContent: "space-between" }}>
//   //         <SearchBar value={searchInput} onChange={(e) => { setSearchInput(e.target.value); setCurrentPage(1); }} />
//   //         <CommonFilter storageName="interactionFilter" setPayloadData={setFilterPayload} isFilter={isFilter} />
//   //       </Box>

//   // {/* Table */}
//   // <TableContainer component={Paper} sx={{ border: "1px solid #EEEEEE", borderRadius: 2, overflowX: "auto", mt: 3 }}>
//   //   <Table>
//   //     <TableHead>
//   //       <TableRow>
//   //         <TableHeading>Agent</TableHeading>
//   //         <TableHeading>Customer</TableHeading>
//   //         <TableHeading>Call Intent</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Campaign</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Duration</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Direction</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Sentiment</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Compliance</TableHeading>
//   //         <TableHeading sx={{ textAlign: "center" }}>Created On</TableHeading>
//   //       </TableRow>
//   //     </TableHead>
//   //     <TableBody>
//   //       {audioList.length === 0 ? (
//   //         <TableRow>
//   //           <TableCell colSpan={10} align="center">
//   //             <NoData />
//   //           </TableCell>
//   //         </TableRow>
//   //       ) : (
//   //         audioList.map((row) => (
//   //           <TableRow key={row.id}>
//   //             <AgentCell row={row} />
//   //             <CustomerCell row={row} />
//   //             <IntentCell intent={row.callIntent} />
//   //             <CampaignCell campaign={row.campaignName} />
//   //             <DurationCell duration={row.callDuration} />
//   //             <DirectionCell direction={row.callDirection} />
//   //             <SentimentCell sentiment={row.overAllSentiment} />
//   //             <ComplianceCell status={row.complianceStatus} rating={row.callAdherenceRating} />
//   //             <DateCell date={row.createdOn} />
//   //           </TableRow>
//   //         ))
//   //       )}
//   //     </TableBody>
//   //   </Table>
//   // </TableContainer>

//   // {/* Pagination */}
//   // <Stack spacing={2} sx={{ mt: 2, display: "flex", alignItems: "flex-end", p: 2 }}>
//   //   <Typography variant="body2" color="text.secondary">
//   //     {paginationInfo.itemCount > 0
//   //       ? `Showing ${(paginationInfo.currentPage - 1) * paginationInfo.perPage + 1}–${Math.min(
//   //           paginationInfo.currentPage * paginationInfo.perPage,
//   //           paginationInfo.itemCount
//   //         )} of ${paginationInfo.itemCount} results`
//   //       : "No results found"}
//   //   </Typography>
//   //   <Pagination
//   //     count={paginationInfo.pageCount || 1}
//   //     page={paginationInfo.currentPage || 1}
//   //     onChange={(e, v) => setCurrentPage(v)}
//   //     sx={{
//   //       "& .MuiPaginationItem-root": { color: "#6366F1", borderColor: "#6366F1" },
//   //       "& .MuiPaginationItem-root.Mui-selected": { backgroundColor: "#6366F1 !important", color: "#fff !important" },
//   //       "& .MuiPaginationItem-root:hover": { backgroundColor: "#E0E7FF" },
//   //     }}
//   //   />
//   // </Stack>
//   //     </Box>
//   //   </Box>
//   // );

//   return (
//     // <Box
//     //   sx={{

//     //     ml: {
//     //       xs: "0px",
//     //       md: "230px",
//     //     },
//     //     minHeight: "100vh",
//     //     p: 3,
//     //     gap: 3,
//     //     display: "flex",
//     //     flexDirection: "column",
//     //   }}
//     // >

//     <ParentWrapper>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <Box>
//           {/* <Typography
//             variant="h5"
//             sx={{
//               fontWeight: 500,
//               color: colorTheme('palette', 'secondary').value
//             }}
//           >
//             {"Interactions"}
//           </Typography>

//           <Typography variant="subtitle1" color="text.secondary">
//             Conversations and call recording uploaded on convoze plateform
//           </Typography> */}

//           {/* <Header title={"Interactions"} subHeading={" Conversations and call recording uploaded on convoze plateform"} /> */}
//         </Box>
//       </Box>

//       <Box>
//         {/* Search + Filters (always visible) */}
//         <Box
//           // sx={{
//           //   borderRadius: 2.5,
//           //   display: "flex",
//           //   justifyContent: "space-between",
//           // }}
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             // backgroundColor : "red",
//             flexDirection: { xs: "column", sm: "row" },
//             gap: 2,
//             "& > *": { width: { xs: "100%", lg: "50%" } },
//           }}
//         >
//           <SearchBar
//             value={searchInput}
//             onChange={(e) => {
//               setSearchInput(e.target.value);
//               setCurrentPage(1);
//             }}
//           />
// <Box
//   sx={{
//     display: "flex",
//     justifyContent : "flex-end",
//     gap: 2,
//     flexDirection: { xs: "column", sm: "row" },
//     // "& > *": { width: { xs: "100%", lg: "50%" } },
//   }}>
//             <CommonFilter
//               storageName="interactionFilter"
//               setPayloadData={setFilterPayload}
//               isFilter={isFilter}
//             />
// <Button
//   variant="contained"
//   color="primary"
//   sx={{ height: "37px", width: { xs: "100%", lg: "150px" }, backgroundColor: "#7635dd", borderRadius: "12px" }}
// onClick={handleExportExcel}
// >
//   Export Excel
// </Button>
//           </Box>
//         </Box>

//         {/* ---------- 1. loading ---------- */}
//         {/* {isLoading && (
//         <Box sx={{ height: 480, display: "flex", alignItems: "center", justifyContent: "center" }}>
//           <Loader />
//         </Box>
//       )} */}

//         {/* ---------- 2. empty ---------- */}
//         {/* {!isLoading && audioList?.length === 0 && (
//           <Box
//             sx={{
//               height: "80vh",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <NoData />
//           </Box>
//         )} */}
//         {isLoading ? (
//           <Loader />
//         ) : (
//           <>
//             {/* Table */}
//             <TableContainer
//               component={Paper}
//               sx={{
//                 // border: "1px solid #EEEEEE",
//                 border: `1px solid ${colorTheme("palette", "white").value}`,
//                 borderRadius: 2,
//                 overflowX: "auto",
//                 mt: 3,
//                 minHeight: "65vh",
//               }}
//             >
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     <TableHeading>Agent</TableHeading>
//                     <TableHeading>Customer</TableHeading>
//                     <TableHeading>Call Intent</TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Campaign
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Duration
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Direction
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Sentiment
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Compliance
//                     </TableHeading>
//                     <TableHeading sx={{ textAlign: "center" }}>
//                       Created On
//                     </TableHeading>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {audioList?.length == 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <NoData />
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     audioList.map((row) => (
//                       <TableRow key={row?.id}>
//                         <AgentCell row={row} />
//                         <CustomerCell row={row} />
//                         <IntentCell intent={row?.callIntent} />
//                         <CampaignCell campaign={row?.campaignName} />
//                         <DurationCell duration={row?.callDuration} />
//                         <DirectionCell direction={row?.callDirection} />
//                         <SentimentCell sentiment={row?.overAllSentiment} />
//                         <ComplianceCell
//                           status={row?.complianceStatus}
//                           rating={row?.callAdherenceRating}
//                         />
//                         <DateCell date={row?.createdOn} />
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             {/* Pagination */}
//             <Stack
//               spacing={2}
//               sx={{ mt: 2, display: "flex", alignItems: "flex-end", p: 2 }}
//             >
//               <Typography variant="body2" color="text.secondary">
//                 {paginationInfo?.itemCount > 0
//                   ? `Showing ${(paginationInfo?.currentPage - 1) *
//                   paginationInfo?.perPage +
//                   1
//                   }–${Math.min(
//                     paginationInfo?.currentPage * paginationInfo?.perPage,
//                     paginationInfo?.itemCount
//                   )} of ${paginationInfo?.itemCount} results`
//                   : "No results found"}
//               </Typography>
//               <Pagination
//                 count={paginationInfo?.pageCount || 1}
//                 page={paginationInfo?.currentPage || 1}
//                 onChange={(e, v) => setCurrentPage(v)}
//                 sx={{
//                   "& .MuiPaginationItem-root": {
//                     color: colorTheme("palette", "primary").value,
//                     borderColor: colorTheme("palette", "primary").value,
//                   },
//                   "& .MuiPaginationItem-root.Mui-selected": {
//                     backgroundColor: `${colorTheme("palette", "primary").value
//                       }, !important`,
//                     color: `${colorTheme("palette", "night").value} !important`,
//                   },
//                   "& .MuiPaginationItem-root:hover": {
//                     backgroundColor: colorTheme("palette", "white").value,
//                   },
//                 }}
//               />
//             </Stack>
//           </>
//         )}
//       </Box>
//     </ParentWrapper>

//     // </Box>
//   );
// };

// export default AudioTable;
